import React, { useState, useEffect, useContext } from "react";
import api from './../../utils/api';
import moment from "moment";
import 'moment/locale/th'
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { Lightbox } from "react-modal-image";
import PolicyConfirmModal from './PolicyConfirmModal';
import { AppContext } from "../context/ContextProvider";
import { numberFormat, inputKeyPressOnlyNumber, optionValue, checkInputIsTaxID, transformFieldWithLang } from './../../utils/functions';
import _ from "lodash";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next'
import { checkPromoCode, getPendingPromo, clearPendingPromo } from '../../utils/promoCode';

moment.locale('th')

const BookingRoomFlexibleModal = ({ show, onHide = () => { } }) => {
  const navigate = useNavigate();
  const { roomSelected, currentHotel, bookStartDate, bookEndDate, bookingData, handleSetRoomSelected, getAgentCodekey } = useContext(AppContext);

  const { t, i18n } = useTranslation()
  const lang = i18n.language || 'th'

  const [form, setForm] = useState({});
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [showConfrimModal, setShowConfrimModal] = useState(false);
  const [showRoomList, setShowRoomList] = useState(false)
  const [acceptPdpa, setAcceptPdpa] = useState(false)
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [couponCode, setCouponCode] = useState('');
  const [discount, setDiscount] = useState(null);

  const [addons, setAddons] = useState([]);
  const [addonOptions, setAddonsOptions] = useState([]);
  const [showSuggestionModal, setShowSuggestionModal] = useState(false);
  const [newBooking, setNewBooking] = useState([])

  const bookingDatesStr = newBooking.map((b) => `${moment(b.date).format('DD/MM/YYYY')} (${numberFormat(b.price, true)})`).join(', ')

  const a = moment(new Date(moment(bookEndDate).format('YYYY-MM-DD')));
  const b = moment(new Date(moment(bookStartDate).format('YYYY-MM-DD')));
  const dayQty = a.diff(b, 'days') || 0
  const totalPrice = _.sumBy(newBooking, (o) => Number(o.price || 0)) || 0

  let discountPrice = 0

  if (discount && (discount?.coupon || discount?.code)) {
    const c = !!discount?.coupon ? discount?.coupon : discount
    const couponDiscountPrice = Number(c.discount_price) || 0

    if (c.discount_type === 'static') {
      if (!!c.allow_static_discount_per_day) {
        const dayLimit = Number(c.discount_day_limit || 0)

        const _days = dayLimit > 0 && dayLimit < dayQty ? dayLimit : dayQty
        discountPrice = couponDiscountPrice * _days
      } else {
        discountPrice = couponDiscountPrice
      }
    } else {
      discountPrice = (Number(totalPrice || 0) || 0) * (couponDiscountPrice / 100)
    }

    if (c.discount_type === 'percent') {
      const dayLimit = Number(c.discount_day_limit || 0)
      const discountLimit = Number(c.discount_price_limit || 0)

      if (dayLimit > 0 && dayLimit < dayQty) {
        let discountPerDays = []
        newBooking.map((_b, _i) => {
          if (_i >= dayLimit) {
            return
          }

          discountPerDays.push((Number(_b.price) || 0) * (couponDiscountPrice / 100) || 0)
        })

        discountPrice = _.sum(discountPerDays) || 0
      }

      if (discountLimit > 0 && discountPrice > discountLimit) {
        discountPrice = discountLimit
      }
    }

    if (discountPrice > Number(totalPrice)) {
      discountPrice = Number(totalPrice)
    }
  } else if (discount && discount?.voucher) {
    discountPrice = Number(totalPrice || 0)
  }

  const sumAddons = _.sumBy(addons || [], (x) => { return Number(x.total_price || 0) }) || 0;

  const depositConfigType = roomSelected?.deposit_enabled ? 'room' : (currentHotel?.deposit_enabled ? 'hotel' : null)

  const depositEnabled = !!depositConfigType
  const depositeType = depositConfigType === 'room' ? roomSelected?.deposit_type : currentHotel?.deposit_type
  const depositValue = depositConfigType === 'room' ? (roomSelected?.deposit_value || 0) : (currentHotel?.deposit_value || 0)

  const depositPrice = depositeType === 'static' ? depositValue : ((Number(totalPrice || 0) - (!!currentHotel?.allow_usediscount_with_patialpayment ? discountPrice : 0)) * (depositValue / 100)) || 0

  const addonPriceForPay = (form.payment_type !== 'deposit' || !currentHotel?.deposit_addon_enabled) ? sumAddons : (depositeType === 'static' ? 0 : (Number(sumAddons) * (depositValue / 100)))

  const allowPayOnStay = !!currentHotel?.allow_payonstay

  const roomDepositEnabled = roomSelected?.room_deposit_enabled || currentHotel?.room_deposit_enabled || false
  const roomDepositPrice = roomDepositEnabled ? (roomSelected?.room_deposit_price || currentHotel?.room_deposit_price || 0) : 0
  const roomDepositPayOnCheckin = currentHotel?.room_deposit_payoncheckin || false
  const roomDepositPayAmount = roomDepositPayOnCheckin ? 0 : roomDepositPrice

  const payAmount = (form.payment_type === 'full' ? (Number(totalPrice || 0) - discountPrice + sumAddons) : (form.payment_type === 'payonstay' ? (sumAddons || 0) : (Number(depositPrice || 0) + Number(addonPriceForPay)))) + Number(roomDepositPayAmount || 0)

  const fetchHotelAddonsItem = (hId) => {
    api.request(`hotel-addons/all`, (data) => {
      setAddonsOptions(data.map((item) => {
        return {
          label: transformFieldWithLang(item, 'name', lang),
          value: item.id,
          _price: item.default_price || 0
        }
      }))
    }, { hotel_id: roomSelected.hotel_id, enabled: true, is_non_inventory: true })
  }

  const validateAddons = () => {
    if (!addons.length) {
      return true
    }

    let l = (addons.filter((x) => !!x.addons_id)) || []

    return l.length === addons.length
  }

  useEffect(() => {
    if (!show) {
      setForm({})
      setCouponCode('')
      setDiscount(null)
      setAddons([])
      return
    }

    setForm({
      ...form,
      payment_type: 'full',
      payment_state: 'waiting',
      state: 'payment',
      booking_date: new Date(),
      start_date: bookStartDate,
      end_date: bookEndDate,
      hotel_id: roomSelected?.hotel_id || currentHotel?.id,
      room_id: null,
      room_flexible_id: roomSelected?.id,
      room_qty: 1,
      booking_note: '',
      slip_file: null
    })

    fetchHotelAddonsItem()

  }, [show])

  const applyCouponCode = (code) => {
    setDiscount(null)

    checkPromoCode(code, {
      hotel_id: currentHotel?.id,
      start_date: moment(form.start_date || bookStartDate).format('YYYY-MM-DD'),
      end_date: moment(form.end_date || bookEndDate).subtract(1, 'days').format('YYYY-MM-DD'),
      room_id: null,
      room_type_id: null,
      room_flexible_id: roomSelected?.id,
      day_qty: dayQty,
      room_qty: Number(form.room_qty || 1),
      from_web: true
    }, (d) => setDiscount(d))
  }

  // รหัสจากหน้ารายละเอียด voucher/คูปอง (กด "จองเลย") -- ใส่ให้และตรวจตามเงื่อนไขปกติ
  useEffect(() => {
    if (!show || !form.start_date) return

    const pending = getPendingPromo(currentHotel?.id)
    if (!pending) return

    setCouponCode(pending.code)
    applyCouponCode(pending.code)
  }, [show, !!form.start_date])

  useEffect(() => {
    if (form?.payment_type !== 'full' && !currentHotel?.allow_usediscount_with_patialpayment) {
      setCouponCode('')
      setDiscount(null)
    }

  }, [form?.payment_type])

  useEffect(() => {
    const _guest = Number(form.guest_qty || 0)
    const _roomQty = Number(form.room_qty || 1)

    const _guestLimit = (Number(roomSelected?.guest_qty || 0) * _roomQty)

    if (_guestLimit > 0 && _guest > _guestLimit) {
      setForm({ ...form, guest_qty: _guestLimit })
      toast.warn(t('guest_qty_exceed_with_addition', { limit: _guestLimit }))
    }
  }, [form.guest_qty])

  useEffect(() => {
    if (!bookingData || !bookingData.length) {
      return
    }

    setNewBooking(bookingData)
  }, [bookingData])

  useEffect(() => {
    const _roomQty = Number(form.room_qty || 0)

    setNewBooking(bookingData.map((item) => {
      return {
        ...item,
        price: _roomQty * Number(item.price || 0)
      }
    }))
  }, [form.room_qty])

  const addonCustomTitle = transformFieldWithLang(currentHotel, 'addons_custom_title', lang)
  const addonCustomWarning = transformFieldWithLang(currentHotel, 'addons_custom_warning', lang)
  const paymentInfo = transformFieldWithLang(currentHotel, 'payment_info', lang)

  return (
    <>
      <Modal size="lg" show={show} onHide={() => onHide(true)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{t('booking_info')} : {transformFieldWithLang(roomSelected, 'name', lang)} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div> <strong>{t('stay_date')} : </strong><span className="ms-2 text-success">{moment(bookStartDate).format('DD/MM/YYYY')} - {moment(bookEndDate).format('DD/MM/YYYY')} ({dayQty} {t('nights')})</span></div>
          <div className="mb-3">
            <span className="text-danger me-2">{t('book_room_qty')} :</span>
            <input
              style={{ width: 80 }}
              className="px-2 py-1"
              type="number"
              name="room_qty"
              placeholder={t('room_qty')}
              min={1}
              onKeyPress={inputKeyPressOnlyNumber} value={form.room_qty || ""}
              onChange={(e) => setForm({ ...form, room_qty: e.target.value })}
              required
            />
          </div>
          <div><span className="text-muted">{t('room_price')} : {bookingDatesStr}</span></div>
          <h5> <strong>{t('total_price')} : </strong><span className="ms-2 text-success">{numberFormat(totalPrice)} {t('currency_unit')}</span></h5>
          {roomDepositPrice > 0 && <div><span className="text-danger">{t('security_deposit')} : {numberFormat(roomDepositPrice, true)} {t('currency_unit')} {roomDepositPayOnCheckin ? `(${t('security_deposit_info_pay_on_stay')})` : `(${t('security_deposit_info_pay_on_booking')})`} </span></div>}
          <hr style={{ color: 'black' }} />
          {((depositEnabled && depositValue > 0) || allowPayOnStay) && <div className="deposit-booking-form">
            <strong>{t('payment_method_choices')} : </strong> {!!currentHotel && !currentHotel?.allow_usediscount_with_patialpayment && <small className="text-muted">{t('discount_partialpayment_not_allowed')}</small>}
            <div className="d-block d-md-flex">
              <label className="form-check  ms-2 ms-md-0">
                <input type="radio" className="form-check-input" checked={form.payment_type === 'full'} onChange={(e) => setForm({ ...form, payment_type: 'full' })} name="paymentType" />
                <span>{t('payment_method_full')}</span>
              </label>
              {(depositEnabled && depositValue > 0) && <label className="form-check ms-2">
                <input type="radio" className="form-check-input" checked={form.payment_type === 'deposit'} onChange={(e) => setForm({ ...form, payment_type: 'deposit' })} name="paymentType" />
                <span>{t('payment_method_deposit')}{depositeType === 'percent' && <span> {numberFormat(depositValue, true)}%</span>} ({numberFormat(depositPrice)} {t('currency_unit')})</span>
              </label>}
              {allowPayOnStay && <label className="form-check ms-2">
                <input type="radio" className="form-check-input" checked={form.payment_type === 'payonstay'} onChange={(e) => setForm({ ...form, payment_type: 'payonstay' })} name="paymentType" />
                <span>{t('payment_method_pay_on_stay')} {roomDepositPayAmount > 0 && <small className="text-danger">({t('pay_security_on_booking_book_on_pay')})</small>}</span>
              </label>}
            </div>
          </div>}
          <div className="booking-form-input">
            {(form.payment_type === 'full' || (!!currentHotel && currentHotel?.allow_usediscount_with_patialpayment)) && <div className="mt-2">
              <strong className="text-warning">{t('discount_coupon')} ({t('optional')})</strong>

              {!discount && <Row className="mb-1">
                <Col xs={8}>
                  <input
                    type="text"
                    name="coupon_code"
                    placeholder={t('specify_discount_code')}
                    value={couponCode || ""}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                </Col>

                <Col xs={4}>
                  <Button disabled={!couponCode?.length} className="btn btn-sm btn-success" onClick={() => applyCouponCode(couponCode)}>
                    {t('use_discount')}
                  </Button>
                  <p className="mb-0 text-danger" onClick={() => setShowSuggestionModal(true)}><i className="fas fa-info-circle pe-1 text-danger" style={{ fontSize: 14 }}></i><small>{t('discount_suggestion')}</small></p>
                </Col>
              </Row>}
              {!!discount && <Row className="mb-1">
                <Col xs={8}>
                  <strong className="text-success"> {t('discount_price', { price: numberFormat(discountPrice) })}</strong>
                </Col>
                <Col xs={4}>
                  <Button className="btn btn-sm btn-danger" onClick={() => {
                    clearPendingPromo(couponCode)
                    setCouponCode('')
                    setDiscount(null)
                  }}>
                    {t('cancel_discount')}
                  </Button>
                </Col>
              </Row>}
            </div>}
            <Row className="mt-4 align-items-end">
              <Col xs={6}>
                <input
                  type="text"
                  value={t('day_qty_stay', { dayQty: dayQty })}
                  readOnly
                />
              </Col>
            </Row>
            <Row className="mt-2">
              {Number(form.guest_qty || 0) <= 0 && <small className="text-danger">* "{t('guest_adult_qty')}" {t('form_required')}</small>}
              <Col xs={6}>
                <input
                  type="number"
                  name="guest_qty"
                  placeholder={t('guest_adult_qty')}
                  min={1}
                  onKeyPress={inputKeyPressOnlyNumber} value={form.guest_qty || ""}
                  onChange={(e) => setForm({ ...form, guest_qty: e.target.value })}
                  required
                />
              </Col>
              <Col xs={6}>
                <input
                  type="number"
                  name="guest_baby_qty"
                  placeholder={t('guest_baby_qty', { age: currentHotel?.custom_guest_baby_age || 6 })}
                  min={1}
                  onKeyPress={inputKeyPressOnlyNumber} value={form.guest_baby_qty || ""}
                  onChange={(e) => setForm({ ...form, guest_baby_qty: e.target.value })}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs={12}>
                {!form.contact_name && <small className="text-danger">* "{t('contact_name')}" {t('form_required')}</small>}
                <input
                  type="text"
                  name="booking_contact_name"
                  placeholder={t('please_specify_contact_name')}
                  value={form.contact_name || ""}
                  onChange={(e) => setForm({ ...form, contact_name: e.target.value })}
                  required
                />
              </Col>
            </Row>
            {!!currentHotel && currentHotel.request_customer_tax_info_enabled && <Row className="mt-2">
              <Col xs={12}>
                {!form.customer_tax_id && <small className="text-danger">* "{t('customer_tax_id')}" {t('form_required')}</small>}
                <input
                  type="text"
                  name="booking_customer_tax_id"
                  placeholder={t('please_specify_customer_tax_id')}
                  onKeyPress={inputKeyPressOnlyNumber}
                  maxLength={13}
                  onBlur={(e) => checkInputIsTaxID(e.target.value)}
                  value={form.customer_tax_id || ""}
                  onChange={(e) => setForm({ ...form, customer_tax_id: e.target.value })}
                  required
                />
              </Col>
            </Row>}
            {!!currentHotel && currentHotel.request_customer_tax_info_enabled && <Row className="mt-2">
              <Col xs={12}>
                {!form.customer_address && <small className="text-warning">* {t('tax_invoice_info')}</small>}
                <textarea
                  type="text"
                  name="customer_address"
                  placeholder={t('tax_invoice_address')}
                  value={form.customer_address || ""}
                  onChange={(e) => setForm({ ...form, customer_address: e.target.value })}
                />
              </Col>
            </Row>}
            <Row className="mt-2">
              {!form.contact_tel_1 && <small className="text-danger">* "{t('contact_tel_1')}" {t('form_required')}</small>}
              <Col xs={6}>
                <input
                  type="text"
                  name="booking_tel_1"
                  placeholder={t('contact_tel_1')}
                  onKeyPress={inputKeyPressOnlyNumber} value={form.contact_tel_1 || ""}
                  onChange={(e) => {
                    if (e.nativeEvent?.inputType === "insertFromPaste" && e.target.value) {
                      const t = e.target.value.replace(/\D/g, '')
                      setForm({ ...form, contact_tel_1: t })
                    } else {
                      setForm({ ...form, contact_tel_1: e.target.value })
                    }
                  }}
                  required
                />
              </Col>
              <Col xs={6}>
                <input
                  type="text"
                  name="booking_tel_2"
                  placeholder={t('contact_tel_2')}
                  onKeyPress={inputKeyPressOnlyNumber} value={form.contact_tel_2 || ""}
                  onChange={(e) => setForm({ ...form, contact_tel_2: e.target.value })}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs={6}>
                <input
                  type="text"
                  name="contact_email"
                  placeholder={t('email')}
                  value={form.contact_email || ""}
                  onChange={(e) => setForm({ ...form, contact_email: e.target.value })}
                />
              </Col>
              <Col xs={6}>
                <input
                  type="text"
                  name="contact_line_id"
                  placeholder={t('line_id')}
                  value={form.contact_line_id || ""}
                  onChange={(e) => setForm({ ...form, contact_line_id: e.target.value })}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs={6}>
                <input
                  type="text"
                  name="customer_car_model"
                  placeholder={t('car_model')}
                  value={form.customer_car_model || ""}
                  onChange={(e) => setForm({ ...form, customer_car_model: e.target.value })}
                />
              </Col>
              <Col xs={6}>
                <input
                  type="text"
                  name="customer_car_license_plate"
                  placeholder={t('car_license_plate')}
                  value={form.customer_car_license_plate || ""}
                  onChange={(e) => setForm({ ...form, customer_car_license_plate: e.target.value })}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs={12}>
                <textarea
                  type="text"
                  name="booking_note"
                  placeholder={t('special_request')}
                  value={form.booking_note || ""}
                  onChange={(e) => setForm({ ...form, booking_note: e.target.value })}
                />
              </Col>
            </Row>
          </div>
          {addonOptions && addonOptions.length > 0 && <div className="mt-2">
            <strong className={`text-${!!addonCustomTitle ? 'danger' : 'warning'}`}>{addonCustomTitle || `${t('addons')} (${t('optional')})`}</strong>
            {!!addonCustomWarning && <small className="ms-2 text-danger">*{addonCustomWarning}</small>}
            <div className="mb-3">
              {addons.map((ad, i) => {
                return (
                  <div className="mt-3" key={`addons-list-${i}`}>
                    <div className="d-block d-md-none mb-3">
                      <div className="top-label" style={{ flex: 1 }}>
                        <Form.Label className="mb-0" htmlFor={`addons_name_${i}`}>{t('addons')} {i + 1}</Form.Label>
                        <Select
                          options={addonOptions}
                          onChange={(option) => {
                            let ads = [...addons]
                            ad.addons_id = option.value
                            ad.unit_price = option._price
                            ad.total_price = ((Number(option._price) * Number(ad.qty)) || 0)
                            ads[i] = ad
                            setAddons(ads)
                          }}
                          className={'flex-fill'}
                          placeholder={t('select_addons')}
                          value={optionValue(ad.addons_id, addonOptions)}
                          classNamePrefix="react-select"
                          id={`addons_name_${i}`}
                        />
                      </div>
                      <div className="d-flex align-items-end">
                        <div className="top-label" style={{ width: 100 }}>
                          <Form.Label className="mb-0" htmlFor={`addons_qty_${i}`}>{t('qty')}</Form.Label>
                          <Form.Control id={`addons_qty_${i}`} type="number" min="1" onKeyPress={inputKeyPressOnlyNumber} value={ad.qty || ""} onChange={(e) => {
                            let ads = [...addons]
                            ad.qty = e.target.value
                            ad.total_price = Number(e.target.value) * Number(ad.unit_price)
                            ads[i] = ad
                            setAddons(ads)
                          }} />
                        </div>
                        <div className="top-label ms-2" style={{ flex: 1 }}>
                          <Form.Label className="mb-0" htmlFor={`addons_price_${i}`}>{t('price')}</Form.Label>
                          <Form.Control id={`addons_price_${i}`} type="text" value={numberFormat(ad.total_price) || ""} disabled />
                        </div>
                        <Button variant="outline-danger" disabled={submitting} className="btn-icon btn-icon-only ms-2 h-50" onClick={() => {
                          let ads = [...addons]
                          ads.splice(i, 1)
                          setAddons(ads)
                        }}>
                          <i className="fa fa-trash" />
                        </Button>
                      </div>
                      <hr style={{ color: 'darkgray' }} />
                    </div>
                    <div className="d-none d-md-flex mb-3">
                      <div className="top-label" style={{ flex: 1 }}>
                        <Form.Label className="mb-0" htmlFor={`addons_name_${i}`}>{t('addons')} {i + 1}</Form.Label>
                        <Select
                          options={addonOptions}
                          onChange={(option) => {
                            let ads = [...addons]
                            ad.addons_id = option.value
                            ad.unit_price = option._price
                            ad.total_price = ((Number(option._price) * Number(ad.qty)) || 0)
                            ads[i] = ad
                            setAddons(ads)
                          }}
                          className={'flex-fill'}
                          placeholder={t('select_addons')}
                          value={optionValue(ad.addons_id, addonOptions)}
                          classNamePrefix="react-select"
                          id={`addons_name_${i}`}
                        />
                      </div>
                      <div className="top-label ms-2" style={{ width: 70 }}>
                        <Form.Label className="mb-0" htmlFor={`addons_qty_${i}`}>{t('qty')}</Form.Label>
                        <Form.Control id={`addons_qty_${i}`} type="number" min="1" onKeyPress={inputKeyPressOnlyNumber} value={ad.qty || ""} onChange={(e) => {
                          let ads = [...addons]
                          ad.qty = e.target.value
                          ad.total_price = Number(e.target.value) * Number(ad.unit_price)
                          ads[i] = ad
                          setAddons(ads)
                        }} />
                      </div>
                      <div className="top-label ms-2" style={{ width: 100 }}>
                        <Form.Label className="mb-0" htmlFor={`addons_price_${i}`}>{t('price')}</Form.Label>
                        <Form.Control id={`addons_price_${i}`} type="text" value={numberFormat(ad.total_price) || ""} disabled />
                      </div>
                      <Button variant="outline-danger" disabled={submitting} className="btn-icon btn-icon-only ms-2" onClick={() => {
                        let ads = [...addons]
                        ads.splice(i, 1)
                        setAddons(ads)
                      }}>
                        <i className="fa fa-trash" />
                      </Button>
                    </div>
                  </div>
                )
              })}

              {addons && addons.length > 0 && <p className="text-primary">{t('addons_summary_price', { price: numberFormat((sumAddons || 0), true) })}
                {(form.payment_type === 'deposit' && !!currentHotel?.deposit_addon_enabled) && addonPriceForPay > 0 && <small className="text-muted ms-2">({t('payment_method_deposit')} {numberFormat(addonPriceForPay, true)} {t('currency_unit')})</small>}
              </p>}
              <Button variant="light" disabled={submitting} className="btn-icon btn-sm" onClick={() => {
                let ads = [...addons]
                ads.push({ name: '', qty: 1, total_price: 0, unit_price: 0 })
                setAddons(ads)
              }}>
                <i className="fa fa-plus me-2" />
                {t('add_addons')}
              </Button>
            </div>
          </div>}
          {!!acceptPdpa && <div>
            <hr />
            {!!paymentInfo && <div>
              <p className="mb-2 text-black">{t('payment_methods')}</p>
              <div className="booking-payment-info">
                <div dangerouslySetInnerHTML={{ __html: paymentInfo }} />
              </div>
            </div>}
            <div className="d-flex mb-2 align-items-end mt-3">
              <div>
                <label htmlFor={`form_file_slip`} className="form-label">{t('attach_slip_payment')}</label>
                <input accept="image/*" className="form-control" id={`form_file_slip`} type="file" onChange={(e) => {
                  if (e?.target?.files && e?.target?.files[0]) {
                    setForm({ ...form, slip_file: e.target.files[0] })
                  }
                }} />
              </div>
              <div className="ms-2" style={{ width: 40 }}>
                {!!form.slip_file &&
                  <img src={URL.createObjectURL(form.slip_file)} className="rounded-sm" style={{ width: 40, height: 40 }} onClick={() => {
                    setIsLightboxOpen(true)
                  }} />}
              </div>
            </div>
          </div>}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center" style={{ flex: 1 }}>
            <h4 style={{ flex: 1 }}>{t('pay_total_amount')} : {numberFormat(payAmount)} {t('currency_unit')}</h4>
            <div>
              <div className="tp-purchase-btn py-3 px-5 rounded" onClick={() => {
                if (!acceptPdpa) {
                  ReactGA.event({
                    category: "BookingProcess",
                    action: `${currentHotel?.code}_${roomSelected?.room_no}_pdpa_click`,
                    label: `Click for PDPA Modal - ${currentHotel?.name_th} : ${roomSelected?.name_th}`,
                  });
                } else {
                  ReactGA.event({
                    category: "Booking Submit Button",
                    action: `${currentHotel?.code}_${roomSelected?.room_no}_submit_booking`,
                    label: `Click for Submit Booking - ${currentHotel?.name_th} : ${roomSelected?.name_th}`,
                  });
                }

                if (!acceptPdpa) {
                  setShowPolicyModal(true)
                } else {

                  if (submitting) {
                    return
                  }

                  if (dayQty < 1) {
                    toast.warn(t('please_specify_stay_date'))
                    return
                  }

                  if (form.room_qty < 1) {
                    toast.warn(t('please_specify_room_qty'))
                    return
                  }

                  if (!form.contact_name) {
                    toast.warn(t('please_specify_contact_name'))
                    return
                  }

                  if (!form.contact_tel_1) {
                    toast.warn(t('please_specify_contact_tel'))
                    return
                  }

                  if (!validateAddons()) {
                    toast.warn(t('please_check_addons'))
                    return
                  }

                  if (!totalPrice || totalPrice < 1) {
                    toast.warn(t('information_invalid_please_check'))
                    return
                  }

                  if (payAmount > 0 && !form.slip_file) {
                    toast.warn(t('please_attach_payment_slip'))
                    return
                  }

                  if (!form.guest_qty || form.guest_qty < 1) {
                    toast.warn(t('please_specify_guest_qty'))
                    return
                  }

                  if (!!currentHotel && currentHotel.request_customer_tax_info_enabled && !form.customer_tax_id) {
                    toast.warn(t('please_specify_customer_tax_id'))
                    return
                  }

                  const agent = getAgentCodekey()

                  setSubmitting(true)

                  const rawForm = {
                    ...form,
                    day_qty: dayQty,
                    room_name: roomSelected?.name_th || '',
                    guest_child_qty: form.guest_child_qty || 0,
                    guest_baby_qty: form.guest_baby_qty || 0,
                    tent_qty: 0,
                    total_price: totalPrice,
                    discount_code: couponCode,
                    total_discount: discountPrice || 0,
                    start_date: moment(form.start_date).format('YYYY-MM-DD'),
                    end_date: moment(form.end_date).subtract(1, 'days').format('YYYY-MM-DD'),
                    deposit_amount: form.payment_type === 'deposit' ? depositPrice : 0,
                    deposit_addon_type: (form.payment_type === 'deposit' && !!currentHotel?.deposit_addon_enabled) ? 'deposit' : 'full',
                    deposit_addon_amount: (form.payment_type === 'deposit' && !!currentHotel?.deposit_addon_enabled) ? Number(addonPriceForPay) : 0,
                    room_deposit_amount: roomDepositPayAmount || 0,
                    room_deposit_outstanding: roomDepositPrice > 0 && roomDepositPayOnCheckin ? roomDepositPrice : 0,
                    sale_agent_id: (agent && agent?.id) ? agent.id : null,
                    room_type_id: null,
                  }

                  const formData = new FormData();
                  for (var key in rawForm) {
                    if (key !== 'slip_file') {
                      formData.append(key, rawForm[key]);
                    }
                  }
                  formData.append("file", rawForm.slip_file);

                  if (addons && addons.length) {
                    addons.map((addonObj, i) => {
                      formData.append(`booking_addons[${i}]`, JSON.stringify(addonObj));
                    })
                  }

                  newBooking.map((b, i) => {
                    formData.append(`booking_items[${i}]`, JSON.stringify(b));
                  })

                  api.request(`bookings/bookingwithroomflexible`, (res, success) => {
                    setSubmitting(false)

                    if (!success) {
                      return
                    } else {
                      toast.success(t('booking_successful'))
                      if (discount && couponCode) clearPendingPromo(couponCode)
                      handleSetRoomSelected({})
                      navigate(`/once/status/${res.id}/${res.booking_no}`)
                    }
                  }, formData, 'POST')
                }
              }}>
                {acceptPdpa ? t('booking_confirmation') : t('next')}{" "}
                <span>
                  <svg
                    width="22"
                    height="8"
                    viewBox="0 0 22 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                  <svg
                    width="22"
                    height="8"
                    viewBox="0 0 22 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          {/* <Button variant="secondary">ถัดไป</Button> */}
        </Modal.Footer>
      </Modal>
      <PolicyConfirmModal
        show={showPolicyModal}
        onHide={() => setShowPolicyModal(null)}
        hotel_id={roomSelected?.hotel_id}
        onAcceptTerm={() => {
          ReactGA.event({
            category: "BookingProcess",
            action: `${currentHotel?.code}_${roomSelected?.room_no}_cf_booking_click`,
            label: `Click for Confirm Booking - ${currentHotel?.name_th} : ${roomSelected?.name_th}`,
          });

          setAcceptPdpa(true)
          setShowPolicyModal(false)
        }}
      />
      <Modal className="fade modal-close-out" show={showSuggestionModal} onHide={() => setShowSuggestionModal(false)}>
        <Modal.Header closeButton />
        <Modal.Body className="d-flex flex-column p-0">
          <img src={"/assets/img/booking/oncecoupon_suggestion.jpg"} alt="img" />
        </Modal.Body>
      </Modal>
      {isLightboxOpen && !!form.slip_file && (
        <Lightbox
          medium={URL.createObjectURL(form.slip_file)}
          large={URL.createObjectURL(form.slip_file)}
          alt={'Payment Slip'}
          onClose={() => {
            setIsLightboxOpen(false)
          }}
          hideDownload
          hideZoom
        />
      )}
    </>
  );
};

export default BookingRoomFlexibleModal;
